import React from "react";
import Icon from "../../Icon/Icon";

export default function RelatedSliderArrows({ slider, isFirstSlide, isLastSlide }) {
	return <div className="rel-content__section__navigation">
		<span
			className={`rel-content__section__navigation__button ${isFirstSlide ? "disabled" : ""}`}
			onClick={() => slider.current.slickPrev()}
		>
			<Icon icon="triangle-arrow-right" />
		</span>
		<span
			className={`rel-content__section__navigation__button ${isLastSlide ? "disabled" : ""}`}
			onClick={() => slider.current.slickNext()}
		>
			<Icon icon="triangle-arrow-right" color="yellow"  />
		</span>
	</div>
}
